import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../assets/css/employeemaster.css";
import Loader from "../components/Loader";
import PageHeader from "../components/PageHeader";
import ReportTable from "../components/ReportTable";
import Pagination from "../components/Pagination";
import {
  fetchEmployees, createEmployee,
  getEmployeeById, updateEmployee,
  deleteEmployee, deleteMessageEmployee
} from "../redux/EmployeeMaster/EmployeeMasterActions";
import { shiftGroupListsApis, shiftList, } from "../redux/shiftgroup/ShiftGroupActions";
import { selectShiftGroupData, selectShiftData, } from "../redux/shiftgroup/ShiftGroupSelector";
import { selectEmployeeData, selectEmployeeMeta, selectSelectedEmployee }
  from "../redux/EmployeeMaster/EmployeeMasterSelector";
import { usersApis } from "../redux/users/userActions";
import { selectUsers } from "../redux/users/userSelectors"
import { isActiveUser } from "../utils/common";
import SkSelect from "../components/SkSelect";
import { isValid } from "date-fns";

const columns = [
  {
    key: "action",
    label: "Action",
  },
  {
    key: "employeeName",
    label: "Employee Name",
  },
  {
    key: "shiftGroup",
    label: "Shift Group",
  },
  {
    key: "shift",
    label: "Shift",
  },
];

function EmployeeMaster() {
  const dispatch = useDispatch();

  const employeeData = useSelector(selectEmployeeData);
  const employeeMeta = useSelector(selectEmployeeMeta);
  const selectedEmployee = useSelector(selectSelectedEmployee);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [filters, setFilters] = useState({
    EmployeeName: "",
    ShiftGroupName: "",
    ShiftName: "",
  });

  const [showEmployeeModal, setShowEmployeeModal] = useState(false);
  const [shiftGroupLoaded, setShiftGroupLoaded] = useState(false);
  const [shiftLoading, setShiftLoading] = useState(false);
  const [usersLoaded, setUsersLoaded] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteEmployee, setSelectedDeleteEmployee] = useState(null);
  const [deleteMessage, setDeleteMessage] = useState("");

  const [employeeForm, setEmployeeForm] = useState({
    EmployeeCode: "",
    EmployeeID: "",
    EmployeeName: "",
    ShiftGroupCode: "",
    ShiftCode: "",
    UserCode: "",
  });

  const [employeeErrors, setEmployeeErrors] = useState({
    EmployeeID: "",
    EmployeeName: "",
    ShiftGroupCode: "",
    ShiftCode: "",
    UserCode: "",
  });

  const shiftGroups = useSelector(selectShiftGroupData);
  const shifts = useSelector(selectShiftData);
  const users = useSelector(selectUsers);

  const filteredShifts = shifts.filter(
    (item) => item.ShiftGroupCode === Number(employeeForm.ShiftGroupCode)
  );
  const hasShifts = filteredShifts.length > 0;

  const buildListPayload = useCallback(() => {

    const payload = {
      PageNumber: currentPage,
      PageSize: pageSize,
    };

    Object.keys(filters).forEach((key) => {

      const value = filters[key];

      if (
        value !== "" &&
        value !== undefined &&
        value !== null
      ) {
        payload[key] =
          typeof value === "string"
            ? value.trim()
            : value;
      }

    });

    return payload;

  }, [filters, currentPage, pageSize]);

  useEffect(() => {
    const loadEmployees = async () => {
      setLoading(true);

      try {
        await dispatch(fetchEmployees(buildListPayload()));
      } catch (error) {
        console.error("Employee list error:", error);
      } finally {
        setLoading(false);
      }
    };

    loadEmployees();
  }, [dispatch, buildListPayload]);

  // useEffect(() => {

  //   const loadEmployee = async () => {
  //     if (!showEmployeeModal) return;

  //     setLoading(true);

  //     try {

  //       await dispatch(fetchEmployees(buildListPayload()));

  //     } catch (error) {

  //       console.error(error);

  //     } finally {

  //       setLoading(false);

  //     }

  //   };

  //   const timer = setTimeout(loadEmployee, 400);

  //   return () => clearTimeout(timer);

  // }, [dispatch, buildListPayload]);

  // useEffect(() => {
  //   if (!selectedEmployee) return;
  //   setEmployeeForm({
  //     EmployeeCode: selectedEmployee.EmployeeCode || "",
  //     EmployeeID: selectedEmployee.EmployeeID || "",
  //     EmployeeName: selectedEmployee.EmployeeName || "",
  //     ShiftGroupCode: selectedEmployee.ShiftGroupCode || "",
  //     ShiftCode: selectedEmployee.ShiftCode || "",
  //     UserCode: selectedEmployee.UserCode || "",
  //   });

  //   dispatch(
  //     shiftList({
  //       PageNumber: 1,
  //       PageSize: 100,
  //       ShiftGroupCode: selectedEmployee.ShiftGroupCode,
  //     })
  //   );
  // }, [selectedEmployee, dispatch]);

  useEffect(() => {
    const loadEmployee = async () => {
      if (!selectedEmployee) return;

      setEmployeeForm({
        EmployeeCode: selectedEmployee.EmployeeCode || "",
        EmployeeID: selectedEmployee.EmployeeID || "",
        EmployeeName: selectedEmployee.EmployeeName || "",
        ShiftGroupCode: selectedEmployee.ShiftGroupCode || "",
        ShiftCode: selectedEmployee.ShiftCode || "",
        UserCode: selectedEmployee.UserCode || "",
      });

      await dispatch(
        shiftList({
          PageNumber: 1,
          PageSize: 100,
          ShiftGroupCode: selectedEmployee.ShiftGroupCode,
        })
      );


    };

    loadEmployee();
  }, [selectedEmployee, dispatch]);

  const data = employeeData.map((item, index) => ({
    id: item.EmployeeCode,
    employeeName: item.EmployeeName?.toUpperCase() || "",
    shiftGroup: item.ShiftGroupName?.toUpperCase() || "",
    shift: item.ShiftName?.toUpperCase() || "",


  }));

  useEffect(() => { }, [employeeForm.ShiftGroupCode, shifts]);

  useEffect(() => { }, [users]);

  // const handleEdit = async (row) => {
  //   setLoading(true);
  //   try {
  //     setShiftGroupLoaded(false);
  //     setUsersLoaded(false);

  //     await dispatch(getEmployeeById(row.id)).unwrap();

  //     setShowEmployeeModal(true);
  //   } catch (err) {
  //     console.log(err);

  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleEdit = async (row) => {

    try {

      const result = await dispatch(
        getEmployeeById(row.id)
      );

      if (getEmployeeById.fulfilled.match(result)) {

        setShowEmployeeModal(true);
      }

      await Promise.all([
        dispatch(
          shiftGroupListsApis({
            PageNumber: 1,
            PageSize: 100,
          })
        ),

        dispatch(
          usersApis({
            PageNumber: 1,
            PageSize: 100,
          })
        ),
      ]);

      setShiftGroupLoaded(true);
      setUsersLoaded(true);
      setShowEmployeeModal(true);

    } catch (err) {

      console.log(err);

    }
  };

  const handleDelete = async (row) => {

    try {
      const response = await dispatch(deleteMessageEmployee(row.id)).unwrap();
      setSelectedDeleteEmployee(row.id);
      setDeleteMessage(response.message);
      setShowDeleteModal(true);
    } catch (err) {
      console.log(err);
    }
  };
  const confirmDeleteEmployee = async () => {
    try {
      setLoading(true);
      await dispatch(deleteEmployee(selectedDeleteEmployee)).unwrap();
      setShowDeleteModal(false);
      setSelectedDeleteEmployee(null);
      setDeleteMessage("");

      dispatch(fetchEmployees(buildListPayload()));
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  const validateEmployeeForm = () => {
    const errors = {};
    if (!employeeForm.EmployeeID.trim()) {
      errors.EmployeeID = "Employee ID is Required";
    } else if (!/^\d+$/.test(employeeForm.EmployeeID.trim())) {
      errors.EmployeeID = "Employee ID must contain numbers only";
    } else if (employeeForm.EmployeeID.trim().length < 2) {
      errors.EmployeeID = "Employee ID must be at least 2 digits";
    } else if (employeeForm.EmployeeID.trim().length > 20) {
      errors.EmployeeID = "Employee ID cannot exceed 20 digits";
    }

    if (!employeeForm.EmployeeName.trim()) {
      errors.EmployeeName = "Employee Name is required";
    } else if (employeeForm.EmployeeName.trim().length < 2) {
      errors.EmployeeName = "Employee Name must be at least 2 characters";
    } else if (!/^[A-Za-z\s.'-]+$/.test(employeeForm.EmployeeName.trim())) {
      errors.EmployeeName = "Employee Name can contain only letters and spaces";
    }

    if (!employeeForm.ShiftGroupCode) {
      errors.ShiftGroupCode = "Please select a Shift Group";
    }

    if (!employeeForm.UserCode) errors.UserCode = "Please Select a User";
    setEmployeeErrors({
      EmployeeID: errors.EmployeeID || "",
      EmployeeName: errors.EmployeeName || "",
      ShiftGroupCode: errors.ShiftGroupCode || "",
      ShiftCode: errors.ShiftCode || "",
      UserCode: errors.UserCode || "",
    });
    return Object.keys(errors).length === 0;
  };

  const handleNewEmployee = async () => {
    // setLoading(true);

    try {
      await Promise.all([
        dispatch(
          shiftGroupListsApis({
            PageNumber: 1,
            PageSize: 100,
          })
        ),
        dispatch(
          usersApis({
            PageNumber: 1,
            PageSize: 100,
          })
        ),
      ]);

      setEmployeeForm({
        EmployeeCode: "",
        EmployeeID: "",
        EmployeeName: "",
        ShiftGroupCode: "",
        ShiftCode: "",
        UserCode: "",
      });

      setEmployeeErrors({
        EmployeeID: "",
        EmployeeName: "",
        ShiftGroupCode: "",
        ShiftCode: "",
        UserCode: "",
      });

      setShiftGroupLoaded(true);
      setUsersLoaded(true);

      setShowEmployeeModal(true);
    } finally {
      // setLoading(false);
    }
  };
  const handleCreateEmployee = async () => {
    const isValid = validateEmployeeForm();

    if (!isValid) {
      return;
    }

    const payload = {
      EmployeeID: employeeForm.EmployeeID.trim(),
      EmployeeName: employeeForm.EmployeeName.trim(),
      ShiftGroupCode: Number(employeeForm.ShiftGroupCode),
      ShiftCode: Number(employeeForm.ShiftCode),
      UserCode: Number(employeeForm.UserCode),
    };

    try {
      setLoading(true);

      await dispatch(createEmployee(payload)).unwrap();
      setShowEmployeeModal(false);

      setEmployeeForm({
        EmployeeID: "",
        EmployeeName: "",
        ShiftGroupCode: "",
        ShiftCode: "",
        UserCode: "",
      });

      setEmployeeErrors({

        EmployeeID: "",
        EmployeeName: "",
        ShiftGroupCode: "",
        ShiftCode: "",
        UserCode: "",
      });

      dispatch(fetchEmployees(buildListPayload()));
    } catch (error) {
      console.error("Create employee error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateEmployee = async () => {
    const isValid = validateEmployeeForm();

    if (!isValid) return;

    const payload = {

      EmployeeID: employeeForm.EmployeeID.trim(),
      EmployeeName: employeeForm.EmployeeName.trim(),
      ShiftGroupCode: Number(employeeForm.ShiftGroupCode),
      ShiftCode: Number(employeeForm.ShiftCode),
      UserCode: Number(employeeForm.UserCode),
    };

    try {
      setLoading(true);
      await dispatch(
        updateEmployee({
          EmployeeCode: employeeForm.EmployeeCode,
          payload,
        })
      ).unwrap();
      setShowEmployeeModal(false);
      setEmployeeForm({
        EmployeeCode: "",
        EmployeeID: "",
        EmployeeName: "",
        ShiftGroupCode: "",
        ShiftCode: "",
        UserCode: "",
      });
      dispatch(fetchEmployees(buildListPayload()));
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleEmployeeChange = (field, value) => {
    setEmployeeForm((prev) => ({
      ...prev,
      [field]: value,
    }));

    setEmployeeErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const loadShiftGroups = async () => {
    if (shiftGroupLoaded || shiftGroups.length > 0) return;

    await dispatch(
      shiftGroupListsApis({
        PageNumber: 1,
        PageSize: 100,
      })
    );

    setShiftGroupLoaded(true);
  };

  const loadShifts = async () => {
    if (!employeeForm.ShiftGroupCode) return;

    setShiftLoading(true);

    await dispatch(
      shiftList({
        PageNumber: 1,
        PageSize: 100,
        ShiftGroupCode: Number(employeeForm.ShiftGroupCode),
      })
    );

    setShiftLoading(false);
  };

  const loadUsers = async () => {
    console.log("loadUsers called");
    if (usersLoaded || (users?.data?.length || 0) > 0) return;
    console.log(users);
    await dispatch(
      usersApis({
        PageNumber: 1,
        PageSize: 100,
      })
    );

    setUsersLoaded(true);
  };

  const handleShiftGroupChange = async (value) => {
    setEmployeeForm((prev) => ({
      ...prev,
      ShiftGroupCode: value,
      ShiftCode: "",
    }));

    setShiftLoading(true);

    await dispatch(
      shiftList({
        PageNumber: 1,
        PageSize: 100,
        ShiftGroupCode: Number(value),
      })
    );

    setShiftLoading(false);
  };

  const handleHeaderFilterChange = useCallback((cf) => {
    const updatedFilters = {};

    if (cf.employeeName?.value) {
      updatedFilters.EmployeeName = cf.employeeName.value;
    }

    if (cf.shiftGroup?.value) {
      updatedFilters.ShiftGroupName = cf.shiftGroup.value;
    }

    if (cf.shift?.value) {
      updatedFilters.ShiftName = cf.shift.value;
    }

    setFilters(updatedFilters);
    setCurrentPage(1);

  }, []);

  return (
    <>
      {loading && <Loader isLoading={true} />}

      <div className="master-page">
        <PageHeader
          icon={<i className="bi bi-person-check"></i>}
          title="Employee Master"
          actions={

            <button className="add-shift-btn" onClick={handleNewEmployee}>
              + New
            </button>

          }
        />
        <div className="employee-data">
          <div className="table-container">
            <ReportTable
              columns={columns}
              data={data}
              serverSide={true}
              stickyColumns={["action"]}
              onHeaderFilterChange={handleHeaderFilterChange}
              renderActions={(row) => (
                <div className="shift-action-buttons">
                  <button
                    className="action-btn edit-btn"
                    onClick={() => handleEdit(row)}
                  >
                    <i className="bi bi-pencil-square"></i>
                  </button>

                  <button
                    className="action-btn delete-btn"
                    onClick={() => handleDelete(row)}
                  >
                    <i className="bi bi-trash-fill"></i>
                  </button>
                </div>
              )}
            />
          </div>
          <Pagination
            currentPage={currentPage}
            totalCount={employeeMeta?.totalRecords || 0}
            pageSize={pageSize}
            onPageChange={setCurrentPage}
            onPageSizeChange={(size) => {
              setPageSize(size);

              setCurrentPage(1);
            }}
          />
        </div>
      </div>

      {showEmployeeModal && (
        <div className="se-overlay">
          <div className="se-modal">
            <div className="se-modal__header">
              <div>
                <h3>
                  {employeeForm.EmployeeCode ? "Edit Employee" : "New Employee"}
                </h3>

                <p className="se-modal__subtitle">
                  {employeeForm.EmployeeCode
                    ? "Update employee details"
                    : "Create a new employee"}
                </p>
              </div>
              <button
                type="button"
                className="se-close"
                onClick={() => {
                  setShowEmployeeModal(false);
                  setShiftGroupLoaded(false);
                  setUsersLoaded(false);

                  setEmployeeForm({
                    EmployeeCode: "",
                    EmployeeID: "",
                    EmployeeName: "",
                    ShiftGroupCode: "",
                    ShiftCode: "",
                    UserCode: "",
                  });
                }}
              >
                <i className="bi bi-x-lg"></i>
              </button>
            </div>

            <div className="se-modal__body">
              <div className="se-section">
                <h4 className="se-section__title">EMPLOYEE DETAILS</h4>

                <div className="se-grid">
                  <div className="se-field">
                    <label>
                      Employee ID <span>*</span>
                    </label>

                    <input
                      type="text"
                      inputMode="numeric"
                      className={`se-input ${employeeErrors.EmployeeID ? "se-input--error" : ""
                        }`}
                      value={employeeForm.EmployeeID}
                      onChange={(e) =>
                        handleEmployeeChange("EmployeeID", e.target.value.replace(/\D/g, ""))
                      }
                      placeholder="Enter Employee ID"
                    />

                    {employeeErrors.EmployeeID && (
                      <span className="error-text">
                        {employeeErrors.EmployeeID}
                      </span>
                    )}
                  </div>

                  <div className="se-field">
                    <label>
                      Employee Name <span>*</span>
                    </label>

                    <input
                      type="text"
                      className={`se-input ${employeeErrors.EmployeeName ? "se-input--error" : ""
                        }`}
                      value={employeeForm.EmployeeName}
                      onChange={(e) =>
                        handleEmployeeChange("EmployeeName", e.target.value)
                      }
                      placeholder="Enter Employee Name"
                    />

                    {employeeErrors.EmployeeName && (
                      <span className="error-text">
                        {employeeErrors.EmployeeName}
                      </span>
                    )}
                  </div>

                  <div className="se-field">
                    <label>
                      Shift Group <span>*</span>
                    </label>

                    <SkSelect
                      value={employeeForm.ShiftGroupCode}
                      onChange={handleShiftGroupChange}
                      onOpen={loadShiftGroups}
                      options={shiftGroups.map((item) => ({
                        value: item.ShiftGroupCode,
                        label: item.ShiftGroupName,
                      }))}
                      placeholder="Select Shift Group"
                      searchable={true}
                    />

                    {employeeErrors.ShiftGroupCode && (
                      <span className="error-text">
                        {employeeErrors.ShiftGroupCode}
                      </span>
                    )}
                  </div>

                  <div className="se-field">
                    <label>
                      Shift <span>*</span>
                    </label>

                    <SkSelect
                      value={employeeForm.ShiftCode}
                      onOpen={loadShifts}
                      onChange={(value) => handleEmployeeChange("ShiftCode", value)}
                      options={filteredShifts.map((item) => ({
                        value: item.ShiftCode,
                        label: item.ShiftName,
                      }))}
                      placeholder={!employeeForm.ShiftGroupCode
                        ? "Select Shift Group first"
                        : hasShifts
                          ? "Select Shift"
                          : "No shift"
                      }
                      searchable={true}

                      disabled={!employeeForm.ShiftGroupCode}
                    />
                    {employeeForm.ShiftGroupCode && !shiftLoading && !hasShifts && (
                      <span className="error-text">
                        No Shift Allocated For This Shift Group
                      </span>
                    )}
                    {employeeErrors.ShiftCode && (
                      <span className="error-text">
                        {employeeErrors.ShiftCode}
                      </span>
                    )}
                  </div>

                  <div className="se-field se-field--full">
                    <label>
                      User <span>*</span>
                    </label>

                    <SkSelect
                      value={employeeForm.UserCode}
                      onOpen={loadUsers}
                      onChange={(value) => handleEmployeeChange("UserCode", value)}
                      /* Active accounts only. This box picks the login a new
                         employee record is tied to, and tying one to a
                         deactivated account creates a person who cannot sign
                         in — the failure would show up days later, at the
                         login screen, with nothing pointing back to here. */
                      options={(users?.data || [])
                        .filter(isActiveUser)
                        .map((item) => ({
                          value: item.UserCode,
                          label: item.UserName,
                        }))}

                      placeholder="Search User"
                      searchable={true}


                    />

                    {employeeErrors.UserCode && (
                      <span className="error-text">
                        {employeeErrors.UserCode}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="se-modal__footer">
              <button
                type="button"
                className="se-btn se-btn--ghost"
                onClick={() => {
                  setShowEmployeeModal(false);
                  setShiftGroupLoaded(false);
                  setUsersLoaded(false);
                }}
              >
                Cancel
              </button>

              <button
                className="se-btn se-btn--primary"
                onClick={
                  employeeForm.EmployeeCode
                    ? handleUpdateEmployee
                    : handleCreateEmployee
                }
              >
                {employeeForm.EmployeeCode ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}

      {showDeleteModal && (
        <div className="se-overlay">
          <div className="se-modal">
            <div className="se-modal__header">
              <h3>Delete Employee</h3>
            </div>

            <div className="se-modal__body">
              <p>{deleteMessage}</p>
            </div>

            <div className="se-modal__footer">
              <button
                className="se-btn se-btn--ghost"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>

              <button
                className="se-btn se-btn--primary"
                onClick={confirmDeleteEmployee}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default EmployeeMaster;
